import { Logger } from "neo-common";
import EventEmitter = PIXI.utils.EventEmitter;

export class Controller extends EventEmitter {
    constructor() {
        super();
    }

    protected log(s: string): void {
        if (DEBUG) {
            var compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Controller.ts
 **/